import './GlobalStyles.css';

export const theme = {
  colors: {
    primary: '#6366f1', // Indigo 500
    primaryLight: '#818cf8', // Indigo 400
    primaryDark: '#4f46e5', // Indigo 600
    secondary: '#8b5cf6', // Violet 500
    secondaryLight: '#a78bfa', // Violet 400
    secondaryDark: '#7c3aed', // Violet 600
    accent: '#f472b6', // Pink 400
    background: '#0f172a', // Slate 900
    surface: '#1e293b', // Slate 800
    surfaceLight: '#334155', // Slate 700
    text: '#f8fafc', // Slate 50
    textSecondary: '#94a3b8', // Slate 400
    textLight: '#64748b', // Slate 500
    border: '#334155', // Slate 700
    borderLight: '#1e293b', // Slate 800
    error: '#ef4444', // Red 500
    warning: '#f59e0b', // Amber 500
    success: '#10b981', // Emerald 500
    info: '#0ea5e9', // Blue 500
    glass: 'rgba(30, 41, 59, 0.7)',
    glassBorder: 'rgba(255, 255, 255, 0.1)',
    card: {
      background: '#1e293b',
      shadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
      shadowHover: '0 8px 30px rgba(0, 0, 0, 0.35)',
      border: '#334155',
      header: '#1e293b',
      body: '#1e293b',
      footer: '#1e293b'
    },
    canvas: {
      background: '#0f172a',
      grid: '#1e293b',
      gridActive: '#6366f1',
      card: {
        background: '#1e293b',
        border: '#334155',
        shadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
      }
    }
  },
  fonts: {
    primary: "'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', 'SF Mono', Monaco, monospace"
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem'
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '5rem'
  },
  borderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    full: '9999px'
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    glow: '0 0 20px rgba(99, 102, 241, 0.4)'
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px'
  },
  transitions: {
    fast: '0.15s cubic-bezier(0.4, 0, 0.2, 1)',
    normal: '0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '0.5s cubic-bezier(0.4, 0, 0.2, 1)'
  },
  cardSize: {
    width: '488px',
    height: '488px',
    borderRadius: '30px'
  },
  loadingSpinner: {
    size: '40px',
    borderWidth: '4px',
    color: '#6366f1',
    background: 'rgba(255, 255, 255, 0.1)'
  }
};

// Export a simple component that just imports the CSS
export const GlobalStyles = () => null; 